import { combineReducers } from 'redux'
import { loadingReducer } from 'redux-foundry'
import {
  API_LISTAR_TIPOS_GASES,
  API_CRIAR_TIPOS_GASES,
  API_EXCLUIR_TIPOS_GASES,
  API_ATUALIZAR_TIPOS_GASES,
} from 'store/modules/api/tiposGases.actions'
import { filter } from 'lodash'

const lista = (state = [], { type, payload }) => {
  switch (type) {
    case API_LISTAR_TIPOS_GASES.success: return payload.sort((a, b) => a.gas.localeCompare(b.gas))
    case API_CRIAR_TIPOS_GASES.success:
      return [...state, payload].sort((a, b) => a.gas.localeCompare(b.gas))
    case API_ATUALIZAR_TIPOS_GASES.success: return state.map((e) => (e.id === payload.id ?
      payload : e))
    case API_EXCLUIR_TIPOS_GASES.success: return filter(state, (o) => o.id !== Number(payload))
    default: return state
  }
}

const isCarregandoLista = loadingReducer(false, API_LISTAR_TIPOS_GASES)

const isSaving = loadingReducer(false, API_CRIAR_TIPOS_GASES)

const isUpdating = loadingReducer(false, API_ATUALIZAR_TIPOS_GASES)

export default combineReducers({
  lista,
  isCarregandoLista,
  isSaving,
  isUpdating,
})
